import { AxiosPromise } from 'axios';
import { OpenAIRequest, PromptType } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const generateAiText = (
    prompt: string,
    systemPrompt: PromptType,
    temperature?: number
): AxiosPromise<string> => {
    const { AiTools } = request();
    return AiTools.aitoolsCompletionPost(prompt, systemPrompt, temperature);
};

export const getGeneratedAiText = (conversationId: string): AxiosPromise<OpenAIRequest[]> => {
    const { AiTools } = request();
    return AiTools.aitoolsCompletionGet(conversationId);
};
